import React from 'react';
import { TodayActionsPanel } from './TodayActionsPanel';
export function DashboardPage() {
  return <main className="min-w-0 px-4 py-7 sm:px-6 lg:px-8" data-id="element-203">
      <TodayActionsPanel data-id="element-204" />
    </main>;
}